export const getAvailableOverlayHeight = (
  anchor: HTMLElement,
  edgeOffset = 50,
  minSpaceBelow = 300,
) => {
  const { bottom } = anchor.getBoundingClientRect();
  const spaceBelow = Math.max(window.innerHeight - bottom, 0);

  if (spaceBelow < minSpaceBelow) {
    // Too cramped to spare any margin
    return window.innerHeight;
  }

  const offset = edgeOffset > spaceBelow ? 0 : edgeOffset;
  return spaceBelow - offset;
};
